module.exports = __webpack_public_path__ + "static/img/360_2.b5253470.png";